import React from 'react';

const Logo = ({ className = "h-10 sm:h-12 w-auto object-contain" }) => {
  return (
    <div className="flex items-center space-x-2">
      {/* 
        NOTE: Gambar logo.jpg/logo.png harus ditempatkan di folder "public" 
        dengan nama file "logo.png" (atau ubah src di bawah sesuai ekstensinya) 
      */}
      <img src="/logo.jpg" alt="ECOngkut Logo" className={className} />
    </div>
  );
};

export default Logo;
